export var SwapBalanceReservationStatusEnum;
(function (SwapBalanceReservationStatusEnum) {
    SwapBalanceReservationStatusEnum["PENDING"] = "pending";
    SwapBalanceReservationStatusEnum["CONFIRMED"] = "confirmed";
    SwapBalanceReservationStatusEnum["CONSUMED"] = "consumed";
    SwapBalanceReservationStatusEnum["RELEASED"] = "released";
    SwapBalanceReservationStatusEnum["EXPIRED"] = "expired";
    SwapBalanceReservationStatusEnum["HELD"] = "held";
})(SwapBalanceReservationStatusEnum || (SwapBalanceReservationStatusEnum = {}));
//# sourceMappingURL=swap-balance-reservation-status.enum.js.map